import Vue from 'vue'
import AssetsMapStorage from '@/localstorage/assetsMap.localstorage'

const state = {
  assets: AssetsMapStorage.get('assets')
    ? JSON.parse(AssetsMapStorage.get('assets'))
    : [],
  newAssets: [],
  // in kilometers
  maxRadius: 0.3,
  maxAssets: 1000
}

const mutations = {
  SET_ASSETS (state, assets) {
    state.assets = assets

    try {
      // AssetsMapStorage.set('assets', JSON.stringify(state.assets))
    } catch (err) {}
  },
  ADD_ASSETS (state, assets) {
    let unsaved = []

    if (!state.assets.length) {
      unsaved = assets
    } else {
      unsaved = assets.filter(asset => {
        return state.assets.findIndex(a => asset.id === a.id) === -1
      })
    }

    if (unsaved.length) {
      state.newAssets = unsaved
      state.assets.push(...unsaved)

      try {
        // AssetsMapStorage.set('assets', JSON.stringify(state.assets))
      } catch (err) {}
    } else {
      state.newAssets = []
    }
  },
  UPDATE_ASSET (state, { id, data }) {
    const index = state.assets.findIndex(asset => asset.id === id)

    if (index > -1) {
      Vue.set(state.assets, index, data)

      try {
        // AssetsMapStorage.set('assets', JSON.stringify(state.assets))
      } catch (err) {}
    }
  },
  SET_STATE (state, data) {
    state[data.state] = data.value
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/assetsMap.module.js